import { render, staticRenderFns } from "./AlboDetail.vue?vue&type=template&id=272a4d20&scoped=true&"
import script from "./AlboDetail.vue?vue&type=script&lang=ts&"
export * from "./AlboDetail.vue?vue&type=script&lang=ts&"
import style0 from "./AlboDetail.vue?vue&type=style&index=0&id=272a4d20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272a4d20",
  null
  
)

export default component.exports